import ClientAgentExtender from '../Common/clientAgentExtender'
import ShieldService from './ShieldService'
import {StoritevEnum} from '../Enum/StoritevEnum'

export default class Shield extends ClientAgentExtender {
  /**
   * @type {number | null}
   * @private
   */
  _idCustomer = null
  /**
   * @type {number | null}
   * @private
   */
  _terminationPointId = null
  /**
   * @type {string | null}
   * @private
   */
  _title = null
  /**
   * @type {boolean | null}
   * @private
   */
  _configurationAllowed = null
  /**
   * @type {boolean | null}
   * @private
   */
  _paketOranzniDiamant = null
  /**
   * @type {boolean | null}
   * @private
   */
  _paketKing = null
  /**
   * @type {boolean | null}
   * @private
   */
  _configured = null
  /**
   * @type {boolean | null}
   * @private
   */
  _configurationChanges = null
  /**
   * @type {Date | null}
   * @private
   */
  _configurationDate = null
  /**
   * @type {string | null}
   * @private
   */
  _device = null
  /**
   * @type {ShieldService | null}
   * @private
   */
  _activeService = null
  /**
   * @type {ShieldService[] | null}
   * @private
   */
  _possibleServices = null
  /**
   * @type {Shield[] | null}
   * @private
   */
  _connectedShields = null
  /**
   * @type {number[] | null}
   * @private
   */
  _toBeConnectedShields = null

  /**
   * @type {boolean}
   * @private
   */
  _loading = false

  _activeTerminationPoints = null
  /**
   * @type {string | null}
   * @private
   */
  _packageDescription = null

  constructor (terminationPointId, customerId) {
    super()
    this._terminationPointId = terminationPointId
    this._idCustomer = customerId
    this._customerId = customerId
  }

  static createFromResponseItem (item, idCustomer) {
    let out = new this(item.id, idCustomer)
    out.loadFromResponseObject(item, idCustomer)
    return out
  }

  loadFromResponseObject (item, idCustomer) {
    this._title = item.title
    this._paketOranzniDiamant = item.paketOranzniDiamant
    this._paketKing = item.paketKing
    this._configurationDate = item.configurationDate === null ? null : new Date(item.configurationDate.date)
    this._configurationAllowed = item.configurationAllowed
    this._configured = item.configured
    this._configurationChanges = item.configured
    this._device = item.device
    this._toBeConnectedShields = []
    this._packageDescription = item.packageDescription
    let activeService = item.activeService !== null
      ? ShieldService.createFromResponseItem(item.activeService, idCustomer, item.id)
      : null
    this._activeService = activeService
    this._possibleServices = []
    if (item.possibleServices !== null) {
      item.possibleServices.forEach((ps) => {
        this._possibleServices.push(ShieldService.createFromResponseItem(ps, idCustomer, item.id))
      })
    }
    this._connectedShields = []
    if (item.connectedShields !== null) {
      item.connectedShields.forEach((cs) => {
        this._connectedShields.push(Shield.createFromResponseItem(cs, idCustomer, item.id))
      })
    }
    this.loadActiveTerminationPoints()
  }

  async loadShield () {
    let request = {terminationPointId: this._terminationPointId}
    let response = await this.ca.makeRequest('t2Shield/terminationPointInfo', request, 'GET')
    this.loadFromResponseObject(response.terminationPointInfo)
  }

  hasActiveServiceWithId (id) {
    return this._activeService !== null && this._activeService.id === id
  }

  loadActiveTerminationPoints () {
    let out = []
    if (this._activeService !== null) {
      let maxConnected = this._activeService.maxConnectedMobiles
      out.push({
        disabled: true,
        shield: this,
        mobilni: this.hasActiveServiceWithId(StoritevEnum.SCITMOB),
        isConnected: false,
        toBeAddedShield: null,
        toBeChangedShield: this._terminationPointId,
        loading: false
      })
      this._connectedShields.forEach((s) => {
        out.push({
          disabled: false,
          shield: s,
          mobilni: true,
          isConnected: true,
          toBeAddedShield: null,
          toBeChangedShield: s.terminationPointId,
          loading: false
        })
      })
      for (let i = this._connectedShields.length; i < maxConnected; i++) {
        out.push({
          disabled: false,
          shield: null,
          mobilni: true,
          isConnected: true,
          toBeAddedShield: null,
          toBeChangedShield: null,
          loading: false
        })
      }
    }
    this._activeTerminationPoints = out
  }

  async editConnectedShield () {
    let request = {terminationPointId: this._terminationPointId, connectedMobileTerminationPoints: []}
    this._activeTerminationPoints.forEach((atp) => {
      if (!atp.disabled) {
        if (atp.toBeChangedShield !== null) {
          request.connectedMobileTerminationPoints.push(atp.toBeChangedShield)
        }
      }
    })
    // request.connectedMobileTerminationPoints.push(newConnectedShield)
    await this.ca.makeRequest('t2Shield/changeConnections', request, 'POST')
  }

  async addNewConnectedShield (newConnectedShield) {
    let request = {
      terminationPointId: this._terminationPointId,
      connectedMobileTerminationPoints: this._connectedShields.map(shield => shield.terminationPointId)
    }
    request.connectedMobileTerminationPoints.push(newConnectedShield)
    await this.ca.makeRequest('t2Shield/changeConnections', request, 'POST')
  }

  /**
   * @param service {ShieldService}
   */
  async activate (service) {
    if (this._toBeConnectedShields.length > service.maxConnectedMobiles) {
      throw new Error('Izbrali ste preveč mobilnih številk')
    }
    let request = {
      terminationPointId: this._terminationPointId,
      serviceId: service.id
    }
    this._toBeConnectedShields.forEach((item) => {
      if (request.connectedMobileTerminationPoints === undefined) {
        request.connectedMobileTerminationPoints = []
      }
      request.connectedMobileTerminationPoints.push(item)
    })
    await this.ca.makeRequest('t2Shield/activate', request, 'POST')
  }

  async deactivate () {
    let request = {
      terminationPointId: this._terminationPointId
    }
    await this.ca.makeRequest('t2Shield/deactivate', request, 'POST')
  }

  async configure () {
    let request = {
      terminationPointId: this._terminationPointId
    }
    return this.ca.makeRequest('t2Shield/configure', request, 'POST')
  }

  async deconfigure () {
    let request = {
      terminationPointId: this._terminationPointId
    }
    return this.ca.makeRequest('t2Shield/deconfigure', request, 'POST')
  }

  async sendOrderRequest () {
    let request = {
      terminationPointId: this._terminationPointId
    }
    return this.ca.makeRequest('t2Shield/equipmentReplacement', request, 'POST')
  }

  get idCustomer () {
    return this._idCustomer
  }

  set idCustomer (value) {
    this._idCustomer = value
  }

  get title () {
    return this._title
  }

  set title (value) {
    this._title = value
  }

  get configurationAllowed () {
    return this._configurationAllowed
  }

  set configurationAllowed (value) {
    this._configurationAllowed = value
  }

  get configured () {
    return this._configured
  }

  set configured (value) {
    this._configured = value
  }

  get device () {
    return this._device
  }

  set device (value) {
    this._device = value
  }

  get activeService () {
    return this._activeService
  }

  set activeService (value) {
    this._activeService = value
  }

  get possibleServices () {
    return this._possibleServices
  }

  set possibleServices (value) {
    this._possibleServices = value
  }

  get connectedShields () {
    return this._connectedShields
  }

  set connectedShields (value) {
    this._connectedShields = value
  }

  get terminationPointId () {
    return this._terminationPointId
  }

  set terminationPointId (value) {
    this._terminationPointId = value
  }

  get customerId () {
    return this._customerId
  }

  set customerId (value) {
    this._customerId = value
  }

  get toBeConnectedShields () {
    return this._toBeConnectedShields
  }

  set toBeConnectedShields (value) {
    this._toBeConnectedShields = value
  }

  get loading () {
    return this._loading
  }

  set loading (value) {
    this._loading = value
  }

  get configurationChanges () {
    return this._configurationChanges
  }

  set configurationChanges (value) {
    this._configurationChanges = value
  }

  get activeTerminationPoints () {
    return this._activeTerminationPoints
  }

  set activeTerminationPoints (value) {
    this._activeTerminationPoints = value
  }

  get paketOranzniDiamant () {
    return this._paketOranzniDiamant
  }

  set paketOranzniDiamant (value) {
    this._paketOranzniDiamant = value
  }

  get paketKing () {
    return this._paketKing
  }

  set paketKing (value) {
    this._paketKing = value
  }

  get configurationDate () {
    return this._configurationDate
  }

  set configurationDate (value) {
    this._configurationDate = value
  }

  get packageDescription () {
    return this._packageDescription
  }

  set packageDescription (value) {
    this._packageDescription = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/T2Shield/Shield.js